import { ProcoColor } from '../utils/proco-color';

export class Rating {
  name: string;
  percentage: number;
  points: number;
  color: ProcoColor;
}
